module.exports = __webpack_public_path__ + "static/images/monet/url_field.png";